import { CSSProperties, ReactNode } from 'react';

import { WorkflowBuilderLayoutHelper } from './helpers/workflow-builder-layout-helper';

interface WorkflowBuilderAgentLayoutProps {
  /** The editor column: the canvas card, and for a host with document tabs, the tab strip above it. */
  children: ReactNode;
  /** The builder agent beside the editor. Null while the host has it closed. */
  agentColumn: ReactNode | null;
}

/** A workflow editor with the builder agent as a full-height column beside it, on the page's own
 * fill. The agent is a sibling of the whole editor column, not a child of it, so it runs the full
 * height rather than starting below the toolbar.
 *
 * `--right-rail-width` publishes the column's width so viewport-pinned chrome inside the editor can
 * clear it; the form preview's testing panel is `fixed`, so it has no other way to know. */
export const WorkflowBuilderAgentLayout = ({
  children,
  agentColumn,
}: WorkflowBuilderAgentLayoutProps) => (
  <div
    className="flex h-screen gap-md bg-bg-light p-md"
    style={
      {
        '--right-rail-width': agentColumn
          ? `${WorkflowBuilderLayoutHelper.AGENT_COLUMN_WIDTH_PX}px`
          : '0px',
      } as CSSProperties
    }
  >
    <div className="flex min-w-0 flex-1 flex-col gap-md">{children}</div>
    {agentColumn}
  </div>
);
